import C from "@/components/forms/Checkbox.module.css";

import { cn } from "@/utils/classNames.ts";
import { Button } from "react-aria-components";

export function WFakeCheckBox({ isSelected, onClick }: { isSelected: boolean; onClick?: (value: boolean) => void }) {
    function onChange() {
        onClick?.(!isSelected);
    }

    return (
        <Button
            data-selected={isSelected ? true : undefined}
            className={cn(C.Checkbox, C.FakeCheckbox)}
            onPress={onChange}
        >
            <div className={C.CheckIcon}>
                <svg viewBox="0 0 18 18" aria-hidden="true">
                    <polyline points="1 9 7 14 15 4" />
                </svg>
            </div>
        </Button>
    );
}
